import React from "react";

const MapEmbed = () => {
  return (
    <iframe
      className="iframeStyle"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20264.913430346067!2d2.935135261491134!3d50.5878310729289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47dd2b0f28a9daf3%3A0x1c0af141f12514a0!2s59211%20Santes!5e0!3m2!1sfr!2sfr!4v1722618852688!5m2!1sfr!2sfr"
      allowFullScreen
      loading="lazy"
      title="Siége social"
    />
  );
};

export default MapEmbed;
